import { ArrowUpRight } from "lucide-react";
import { useUnreadChangelogCount } from "@/lib/api/changelog";
import { useChangelogStore } from "@/lib/hooks/use-changelog-store";

export function WhatsNewPill() {
  const { data: unreadCount } = useUnreadChangelogCount();
  const openModal = useChangelogStore((s) => s.openModal);

  if (!unreadCount || unreadCount === 0) return null;

  return (
    <button
      type="button"
      onClick={openModal}
      aria-label={`What's new — ${unreadCount} unread update${
        unreadCount === 1 ? "" : "s"
      }`}
      className="fixed bottom-4 left-4 z-[51] flex w-[280px] flex-col items-start gap-1 overflow-hidden rounded-2xl border border-[#e2e2e2] bg-white p-6 text-left shadow-[1px_5px_12px_0_rgba(153,153,153,0.1),4px_21px_21px_0_rgba(153,153,153,0.09),9px_47px_29px_0_rgba(153,153,153,0.05)] transition-shadow hover:shadow-[4px_21px_21px_0_rgba(153,153,153,0.12),9px_47px_29px_0_rgba(153,153,153,0.08)] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2"
    >
      <div className="flex w-full items-center justify-between gap-2">
        <span className="text-base leading-6 text-[#1c1c1c]">
          What&rsquo;s new?
        </span>
        <ArrowUpRight className="size-6 shrink-0 text-[#1c1c1c]" />
      </div>
      <span className="text-sm leading-5 text-[#777]">
        Click here to see new updates
      </span>
    </button>
  );
}
